import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";

import {TopPerformersWidgetConfig} from "./top-performers-widget.config";
import {TopPerformersWidgetStore} from "./top-performers-widget.store";
import {TopPerformersWidgetHandlers} from "./handlers/top-performers-widget.handlers";

export class TopPerformersWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  TopPerformersWidgetConfig, TopPerformersWidgetStore, TopPerformersWidgetHandlers];

}
